(function () {
  if (window.footerWishlistDrawerInitialized) return;
  window.footerWishlistDrawerInitialized = true;

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
      return;
    }

    var footerWishlistLink = event.target.closest('.footer [data-open-wishlist-drawer]');
    if (!footerWishlistLink) return;

    var wishlistTrigger = document.querySelector('.stackdcontinuity-drawer-trigger');

    if (!wishlistTrigger) return;

    event.preventDefault();
    wishlistTrigger.click();
  });
})();
